import ky from "ky";
import { getRecaptchaToken, isRecaptchaForm } from "@features/recaptcha/events";

export class ProductInquiryForm extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.addEventListener("submit", this.handleSubmit);
  }

  async handleSubmit(event: SubmitEvent) {
    const form = event.target as HTMLFormElement;

    event.preventDefault();

    if (isRecaptchaForm(form)) {
      const token = await getRecaptchaToken("inquiry");
      const input = form.querySelector<HTMLInputElement>('input[name="grecaptcha"]');
      if (input != null) {
        input.value = token;
      }
    }

    const fd = new FormData(form);
    const url = form.action;

    const response = await ky.post(url, {
      body: fd,
      throwHttpErrors: false,
    });

    const resultEl = this.querySelector<HTMLDivElement>('[data-id="inquiry-result"]');
    if (!resultEl) return;
    const titleEl = resultEl.querySelector<HTMLSpanElement>('[data-id="inquiry-result-title"]');
    const messageEl = resultEl.querySelector<HTMLSpanElement>('[data-id="inquiry-result-message"]');

    form.classList.add("!hidden");
    resultEl.classList.remove("hidden");
    resultEl.classList.add("flex");
    if (response.ok) {
      resultEl.firstElementChild!.classList.add("bg-green-100");
      titleEl!.classList.add("text-green-800");
      messageEl!.classList.add("text-green-700");
      titleEl!.textContent = this.dataset.localizerSentTitle as string;
      messageEl!.textContent = this.dataset.localizerSentMessage as string;
    } else {
      resultEl.firstElementChild!.classList.add("bg-red-100");
      titleEl!.classList.add("text-red-800");
      messageEl!.classList.add("text-red-700");
      titleEl!.textContent = this.dataset.localizerFailedTitle as string;
      messageEl!.textContent = this.dataset.localizerFailedMessage as string;
    }
  }
}

export function registerProductInquiryForm() {
  customElements.define("product-inquiry-form", ProductInquiryForm);
}

